import React from 'react'

import {connect} from 'react-redux'
import SalesNotes from "./component/SalesNotes";
import {PricesProvider} from "./PricesContext";
// import * as selector from "../treatment/state/quotation/selector";
import {ROLE_CLINIC_SALES} from "../security/state/auth/const";
import Authorization from '../security/component/auth/AuthorizationContainer';
import * as selector from '../customer/state/detail/selector'
import {SALES_NOTE_WIDGET_CONTAINER} from "../process/ui-definition/process-ui";


// this container is for BC with Redux, to be removed later

const mapStateToProps = (state, props) => {
    const customer = selector.selectCustomer(state) || {};

    return {
        isReadOnly: props.readOnly,
        countryCode: customer.countryCode,
        customerId: customer.id,
        state: state,
    }
}

const mapDispatchToProps = {}

const SalesNoteWidgetContainer = ({countryCode, customerId, isReadOnly, state}) => {
    if (!customerId) {
        return;
    }

    return (
        <Authorization requiredRole={ROLE_CLINIC_SALES}
                          widgetName={SALES_NOTE_WIDGET_CONTAINER}>
            <PricesProvider countryCode={countryCode}>
                <SalesNotes customerId={customerId} isReadOnly={isReadOnly} state={state}/>
            </PricesProvider>
        </Authorization>
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(SalesNoteWidgetContainer)



// WEBPACK FOOTER //
// ./src/modules/sales/SalesNoteWidgetContainer.js